import { QuickSearchResult3 } from "../../api";
import { useTranslations } from "../../hooks/useTranslations";
import UrlBuilder from "../../services/UrlBuilder";
import A from "../html/A";
import Img from "../html/Img";

interface QuickSearchResultProps {
	query: string;
	searchResult: QuickSearchResult3;
	searchPageUrl: string;
}

export default function QuickSearchResult({
	query,
	searchResult,
	searchPageUrl,
}: QuickSearchResultProps) {
	const { products, categories, pages } = searchResult;
	const t = useTranslations();
	const isEmptySearchResult =
		products?.length === 0 && categories?.length === 0 && pages?.length === 0;
	const searchPageUrlWithQuery = searchPageUrl
		? new UrlBuilder(searchPageUrl).setParam("q", query).toString()
		: "";

	return (
		<div className="border-[color:var(--color-light-grey)] fixed top-[var(--header-height)] right-0 left-0 max-h-[calc(70vh-64px)] overflow-y-auto rounded-br-md rounded-md border border-solid bg-white p-3.5 md:absolute md:top-10 md:right-0 md:left-0 md:max-h-none">
			{isEmptySearchResult ? (
				<p className="m-0">{t.noProductsFound}</p>
			) : (
				<>
					{products.length > 0 && (
						<div>
							<h3 className="text-independence text-xs font-medium text-light-black uppercase">{t.products}</h3>
							<ul className="mt-2.5 grid gap-2">
								{products.map((product) => (
									<li key={product.partNo}>
										<A
											href={product.url}
											className="break-word flex items-center gap-3"
											key={product.partNo}
										>
											<div className="border-[color:var(--color-light-grey)] flex aspect-square w-12 flex-shrink-0 flex-grow-0 rounded border border-solid p-1.5">
												<Img src={product.image.url} alt={product.image.altText} className={"object-cover"} />{" "}
											</div>
											<div>
												<p className="text-light-black m-0 text-sm font-light">
													{product.name}
												</p>
												<p className="text-independence m-0 text-xs font-normal text-light-black">
													{t.eNumber}: {product.eNumber}
												</p>
											</div>
										</A>
									</li>
								))}
							</ul>
						</div>
					)}
					{categories.length > 0 && (
						<div>
							{products && products.length > 0 && (
								<hr className="border-top border-[color:var(--color-pale-blue)] my-6 border-solid" />
							)}
							<h3 className="text-independence text-xs font-medium text-light-black uppercase">{t.categories}</h3>
							<ul className="mt-2.5 grid gap-2">
								{categories.map((category, index) => (
									<li key={index}>
										<A
											href={category.url}
											className="text-light-black m-0 text-sm font-light"
										>
											{category.name}
										</A>
									</li>
								))}
							</ul>
						</div>
					)}
					{pages.length > 0 && (
						<div>
							{((products && products.length > 0) || (categories && categories.length > 0)) && (
								<hr className="border-top border-[color:var(--color-pale-blue)] my-6 border-solid" />
							)}
							<h3 className="text-independence text-xs font-medium text-light-black uppercase">{t.pages}</h3>
							<ul className="mt-2.5 grid gap-2">
								{pages.map((page, index) => (
									<li key={index}>
										<A
											href={page.url}
											className="text-light-black m-0 text-sm font-light"
										>
											{page.name}
										</A>
									</li>
								))}
							</ul>
						</div>
					)}
					{searchPageUrlWithQuery && (
						<a
							className="button-primary-large-extended mt-4"
							href={searchPageUrlWithQuery}
						>
							{t.totalHits}
						</a>
					)}
				</>
			)}
		</div>
	);
}
